export default __webpack_public_path__ + "static/media/pictogramBeaconFamily128.c5a9b853.svg";